import React from 'react';
import * as S from './styles';
import Events from '../../Events';
import Aguas from '../../../front-novo/icons/Aguas.svg';
import Pequi from '../../../front-novo/icons/Pequi.svg';
import Tronco from '../../../front-novo/icons/Tronco.svg';
import Sol from '../../../front-novo/icons/Sol.svg';
import Gaviao from '../../../front-novo/icons/Gaviao.svg';
import bordercardimg from '../../../front-novo/home/bordercardimg.png';

function Home5() {
  return (
    <S.Main>
      <S.Section>
        <S.TextDiv>
          <h1>Conheça nosso canal</h1>
          <p>
            Acesse as gravações de seminários e lives no nosso canal do YouTube
          </p>
          <div>
            <a
              href="https://www.youtube.com/channel/UCLn3J16_ujB95kuQnLVBX3g"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button>Acesse agora</button>
            </a>
          </div>
        </S.TextDiv>
      </S.Section>
    </S.Main>
  );
}

export default Home5;
